import {
  MICROSOFT_POSTURE_STATES,
  POSTURE_STATE_TO_MSG,
  POSTURE_STATE_COLOR_CODES,
  AUGMENTT_POSTURE_STATES,
} from "./constants";
import postureConfig from "./postureConfig";

// format single security check data as the table ones
// so we can reuse utils functions on them
export const summarizeSecurityCheck = (securityCheckData) => {
  const compliantCount = securityCheckData?.compliance?.compliant?.length ?? 0;
  const nonCompliantCount =
    securityCheckData?.compliance?.nonCompliant?.length ?? 0;
  const totalCount = securityCheckData?.compliance?.settings?.length;

  return {
    ...securityCheckData,
    status: securityCheckData?.configuration?.status,
    securityCheck: securityCheckData?.checkType,
    compliance: {
      ...securityCheckData?.compliance,
      compliant: compliantCount,
      nonCompliant: nonCompliantCount,
      total: totalCount || compliantCount + nonCompliantCount,
    },
  };
};

export const getPostureStatus = (posture) => {
  if (
    posture?.msSecureScore?.scoreControlState &&
    posture?.msSecureScore?.scoreControlState !==
      MICROSOFT_POSTURE_STATES.DEFAULT &&
    !(
      posture?.msSecureScore?.scoreControlState ===
        MICROSOFT_POSTURE_STATES.RISK_ACCEPTED &&
      posture.status === AUGMENTT_POSTURE_STATES.COMPLIANT
    )
  ) {
    return posture?.msSecureScore?.scoreControlState;
  }
  return posture.status;
};

export const getPostureStatusMessage = (posture, intl) => {
  const status = getPostureStatus(posture);
  if (POSTURE_STATE_TO_MSG[status]) {
    return intl.formatMessage({ id: POSTURE_STATE_TO_MSG[status] });
  }
  return status;
};

export const getPostureStatusDetails = (posture) => {
  if (
    posture?.msSecureScore?.scoreControlComment &&
    posture?.msSecureScore?.scoreControlState !==
      MICROSOFT_POSTURE_STATES.DEFAULT &&
    !(
      posture?.msSecureScore?.scoreControlState ===
        MICROSOFT_POSTURE_STATES.RISK_ACCEPTED &&
      posture.status === AUGMENTT_POSTURE_STATES.COMPLIANT
    )
  ) {
    return posture?.msSecureScore?.scoreControlComment;
  }
  return postureConfig?.[posture.securityCheck]?.statusDetailsFormatter(
    posture
  );
};

export const getPostureColorCode = (posture) =>
  POSTURE_STATE_COLOR_CODES[posture.status];

const addToOptionsMap = (optionsMap, value) => {
  // eslint-disable-next-line no-param-reassign
  optionsMap[value] = optionsMap[value] ? optionsMap[value] + 1 : 1;
};

export const createOptions = (tableData, field) => {
  const optionsMap = {};
  tableData?.forEach((item) => {
    if (Array.isArray(item?.[field])) {
      item?.[field]?.forEach((value) => {
        optionsMap[value] = optionsMap[value] ? optionsMap[value] + 1 : 1;
      });
    } else if (item?.[field]) {
      addToOptionsMap(optionsMap, item?.[field]);
    }
  });
  return Object.entries(optionsMap).map((entry) => ({
    label: entry[0],
    value: entry[0],
    count: entry[1],
  }));
};
